module.exports = __webpack_public_path__ + "img/alert.d87abea4.svg";